import type { OwnedDbOperationResult } from "@9amhealth/shared";
import { ensureOwnership, getDb, runForOwner } from "./DbService";

const STATUS_KEY = "all";
const META_KEY = "statuses";

export const DbJourneyStatusService = {
  async get(): Promise<Record<string, unknown>[] | undefined> {
    await ensureOwnership();
    const db = getDb();
    const row = await db.journeyStatuses.get(STATUS_KEY);
    return row?.data;
  },

  async putForOwner(
    expectedOwnerId: string | null,
    data: Record<string, unknown>[],
    lastFetchAt: number
  ): Promise<OwnedDbOperationResult<void>> {
    return runForOwner(expectedOwnerId, (db) =>
      db.transaction("rw", db.journeyStatuses, db.meta, async () => {
        await db.journeyStatuses.put({ key: STATUS_KEY, data });
        await db.meta.put({ key: META_KEY, lastFetchAt });
      })
    );
  },

  async invalidateForOwner(
    expectedOwnerId: string | null
  ): Promise<OwnedDbOperationResult<void>> {
    return runForOwner(expectedOwnerId, (db) =>
      db.transaction("rw", db.journeyStatuses, db.meta, async () => {
        await db.journeyStatuses.delete(STATUS_KEY);
        await db.meta.delete(META_KEY);
      })
    );
  }
};
